<template>
  <div>
    <div class="dib vue-ui-select">
      <div v-if="this.currentArea" class="vue-ui-select-text">
        {{this.currentArea}}
      </div>
      <div v-else class="vue-ui-select-placeholder">
        Escolha a diretoria
      </div>
      <img :src="Arrow" />
      <select @change="areaChanged" v-if="areas.length > 0">
        <option v-for="(a, i) in areas" :key="a" :value="a">{{a}}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import EventSystem from '../utils/EventSystem';
  import Arrow from 'Assets/images/arrow.svg';

  export default {
    data() {
      return {
        currentFront: window.$fronts ? window.$fronts[0] : { name: '' },
        currentArea: null,
        fronts: window.$fronts || [],
        areas: ['Todas'],
        Arrow,
      };
    },
    created() {
      EventSystem.$on('front-changed', front => this.updateSelect(front));
      EventSystem.$on('first-front-selected', front => this.updateSelect(front));
      EventSystem.$on('fronts-loaded', this.updateSelect);
      EventSystem.$on('areas-loaded', this.updateAreaSelect);
    },
    methods: {
      changed (evt) {
        this.currentFront = this.fronts[evt.target.value];
        this.currentArea = null;
        EventSystem.$emit('front-changed', this.currentFront);
      },
      areaChanged(evt) {
        this.currentArea = evt.target.value;
        EventSystem.$emit('area-changed', this.currentArea);
      },
      updateSelect(front) {
        this.fronts = window.$fronts;
        this.currentArea = null;
        this.currentFront = front || window.$fronts[0];
      },
      updateAreaSelect() {
        this.areas = ['Todas', ...window.$areas];
      },
    },
  };
</script>




// WEBPACK FOOTER //
// assets/js/source/vue-ui/area-select.vue